<template>
	<app-dropdown
		v-if="operators"
		v-model="val"
		label-key="name"
		value-key="id"
		size="small"
		:options="operators"
		:v-model="modelValue"
		:disabled="disabled"
		@update:model-value="updateValue">
		{{ label }}
	</app-dropdown>

	<app-loader v-else />
</template>

<script lang="ts" setup>
	import { ref, computed, onMounted, watch } from 'vue'
	import useOperatorStore from '@/stores/operators'

	const store = useOperatorStore()
	const val = ref()

	const props = withDefaults(
		defineProps<{
			modelValue?: string
			label?: string
			disabled?: boolean
		}>(),
		{
			modelValue: undefined,
			label: 'Select Operator'
		}
	)

	const operators = computed(() => {
		return store.operators
	})

	watch(
		() => props.modelValue,
		(newValue) => {
			val.value = newValue
		}
	)

	const emit = defineEmits(['update:modelValue'])
	function updateValue(value: string | string[]) {
		val.value = value
		emit('update:modelValue', value)
	}

	onMounted(() => {
		if (props.modelValue) {
			val.value = props.modelValue
		}
	})
</script>
